import style from './Home.module.scss'

export default function Home() {
  return (
    <div></div>
  )
}
